import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { DepotOverview } from '@models/resources/depot.model';

/**
 * Facade für die Depot-Übersicht (Sprint 2, Story S2-1).
 *
 * Zwei konkrete Implementierungen:
 * - `DummyCustomerDepotFacade` – liest `DEMO_DEPOT_OVERVIEW` mit Latenz.
 * - `HttpCustomerDepotFacade` – Stub, bis Sprint 4 `GET /api/me/depot` liefert.
 *
 * Gebunden in `app.config.ts` via `environment.dataSource`.
 */
export interface CustomerDepotFacade {
  getOverview(): Observable<DepotOverview>;
}

export const CUSTOMER_DEPOT_FACADE = new InjectionToken<CustomerDepotFacade>(
  'CustomerDepotFacade',
);
